// LIBRARIES IMPORT

// Library: Masonry and Isotope
import Masonry from "masonry-layout"
import imagesLoaded from "imagesloaded"
// Library: Vanilla Lazyload
import LazyLoad from "vanilla-lazyload"
// Library: Flickity
import Flickity from "flickity"
import 'flickity/dist/flickity.min.css'
// Library: Underscore
import _, { map } from 'underscore'
// Library: GSAP and Draggable
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
// Library: Lottie
import lottie from "lottie-web/build/player/lottie_light"

// Variables
const small = 799
const overSmall = 800


// EVENTS
// Scrollgeschwindigkeiten von #eventsAside und #veranstaltungsreihen angleichen
let gsapAnimation
function eventsScrollSync() {
  const eventsAside = document.getElementById('eventsAside')
  const eventsVeranstaltungsreihen = document.getElementById('veranstaltungsreihen')
  if (eventsAside && eventsVeranstaltungsreihen) {
  
    let largerElement = eventsVeranstaltungsreihen
    let smallerElement = eventsAside
  
    if (eventsAside.clientHeight > eventsVeranstaltungsreihen.clientHeight) {
      largerElement = eventsAside
      smallerElement = eventsVeranstaltungsreihen
    }
  
    if (smallerElement.clientHeight > (window.innerHeight - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bar-height')) * 3) && window.innerWidth >= overSmall) {
      gsap.registerPlugin(ScrollTrigger)
      smallerElement.style = ''
      // console.log(largerElement.clientHeight + '–' + smallerElement.clientHeight + '=' + (largerElement.clientHeight - smallerElement.clientHeight))
      gsapAnimation = gsap.to(smallerElement, {
        y: (largerElement.clientHeight - smallerElement.clientHeight), // Endposition
        ease: "none",
        scrollTrigger: {
          scroller: eventsAside.parentElement.parentElement,
          trigger: largerElement,
          start: "top top", // Start bei unterem Ende des Viewports
          end: "bottom bottom", // Ende bei oberem Ende des Viewports
          scrub: true, // Glätte die Animation mit Scrollen
          // markers: true,
          // onUpdate: (self) => console.log("progress:", self.progress),
        },
      });
    } else {
      if (gsapAnimation) {
        gsapAnimation.kill()
      }
      smallerElement.style = ''
      smallerElement.style.position = 'sticky'
      smallerElement.style.top = '0'
    }
  }
}
window.addEventListener('resize', _.debounce(eventsScrollSync, 1000))


// STUDIUM
// Scrollgeschwindigkeiten von #eventsAside und #studiumContent angleichen
let gsapAnimationStudium
function studiumScrollSync() {
  const eventsAside = document.getElementById('eventsAside')
  const studiumContent = document.querySelector('#studiumContent .sections')
  if (eventsAside && studiumContent) {
    let largerElement = studiumContent
    let smallerElement = eventsAside
  
    if (eventsAside.clientHeight > studiumContent.clientHeight) {
      largerElement = eventsAside
      smallerElement = studiumContent
    }
  
    if (smallerElement.clientHeight > (window.innerHeight - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bar-height')) * 3) && window.innerWidth >= overSmall) {
      gsap.registerPlugin(ScrollTrigger)
      smallerElement.style = ''
      // console.log(largerElement.clientHeight + '–' + smallerElement.clientHeight + '=' + (largerElement.clientHeight - smallerElement.clientHeight))
      gsapAnimationStudium = gsap.to(smallerElement, {
        y: (largerElement.clientHeight - smallerElement.clientHeight), // Endposition
        ease: "none",
        scrollTrigger: {
          scroller: eventsAside.parentElement.parentElement,
          trigger: largerElement,
          start: "top top", // Start bei unterem Ende des Viewports
          end: "bottom bottom", // Ende bei oberem Ende des Viewports
          scrub: true, // Glätte die Animation mit Scrollen
          // markers: true,
          // onUpdate: (self) => console.log("progress:", self.progress, largerElement.clientHeight - smallerElement.clientHeight),
        },
      });
    } else {
      if (gsapAnimationStudium) {
        gsapAnimationStudium.kill()
      }
      smallerElement.style = ''
      smallerElement.style.position = 'sticky'
      smallerElement.style.top = '0'
    }
  }
}
window.onload = () => {
  studiumScrollSync()
  eventsScrollSync()
}
window.addEventListener('resize', _.debounce(studiumScrollSync, 1000))

// Scrollgeschwindigkeiten von #beitragMedien und #beitragText angleichen
let gsapBeitragAnimation
function resetBeitragMediaColumnLayout(mediaColumn) {
  if (!mediaColumn) {
    return
  }
  mediaColumn.style.overflow = ''
  mediaColumn.style.maxHeight = ''
  mediaColumn.style.position = ''
  mediaColumn.style.top = ''
  mediaColumn.style.alignSelf = ''
}

function enableBeitragContainerScrollFallback(mediaColumn) {
  if (!mediaColumn) {
    return
  }
  mediaColumn.style.overflow = 'visible'
  mediaColumn.style.maxHeight = 'none'
  mediaColumn.style.position = 'static'
  mediaColumn.style.top = 'auto'
  mediaColumn.style.alignSelf = 'stretch'
}

function resetBeitragTextSticky(textColumn) {
  if (!textColumn) {
    return
  }
  textColumn.style.position = ''
  textColumn.style.top = ''
  textColumn.style.alignSelf = ''
}

function enableBeitragTextSticky(textColumn) {
  if (!textColumn) {
    return
  }
  textColumn.style.position = 'sticky'
  textColumn.style.top = '0'
  textColumn.style.alignSelf = 'flex-start'
}

function beitragScrollSync() {
  const beitrag = document.getElementById('beitrag')
  const beitragMedienColumn = document.getElementById('beitragMedien')
  const beitragMedien = document.querySelector('#beitragMedien .inner-container')
  const beitragText = document.getElementById('beitragText')
  const barHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bar-height'))
  const maxVisibleColumnHeight = window.innerHeight - barHeight * 3
  const mediaNeedsScroll = beitragMedien && (beitragMedien.clientHeight > maxVisibleColumnHeight)
  const textTooShortForSync = beitragText && (beitragText.clientHeight <= maxVisibleColumnHeight)
  // console.log(beitragMedien.clientHeight, window.innerHeight - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bar-height')) * 3), (beitragMedien.clientHeight > window.innerHeight - Number(getComputedStyle(document.documentElement).getPropertyValue('--bar-height')) * 3)
  // console.log(parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bar-height')))

  if (window.innerWidth >= overSmall && mediaNeedsScroll && !textTooShortForSync) {
    gsap.registerPlugin(ScrollTrigger)
    gsapBeitragAnimation && gsapBeitragAnimation.revert()
    resetBeitragMediaColumnLayout(beitragMedienColumn)
    resetBeitragTextSticky(beitragText)
    gsapBeitragAnimation = gsap.matchMedia().add("(min-width: 720px)", () => {

      gsap.to(beitragMedien, {
        y: (-beitragMedien.clientHeight + beitrag.clientHeight), // Endposition
        ease: "none",
        scrollTrigger: {
          scroller: beitragMedien.parentElement.parentElement,
          trigger: beitragText,
          start: "top top", // Start bei unterem Ende des Viewports
          end: "bottom bottom", // Ende bei oberem Ende des Viewports
          scrub: true, // Glätte die Animation mit Scrollen
          // markers: true,
          // onUpdate: (self) => {
          //   console.log("progress:", self.progress)
          //   console.log(beitragText.clientHeight + " - " + beitragMedien.clientHeight + " = " + (beitragText.clientHeight - beitragMedien.clientHeight), self.progress.toFixed(2))
          // },
        },
      });

    })
  } else if (window.innerWidth >= overSmall && mediaNeedsScroll && textTooShortForSync) {
    gsapBeitragAnimation && gsapBeitragAnimation.kill()
    gsapBeitragAnimation = null
    gsap.set(beitragMedien, { clearProps: 'transform' })
    enableBeitragContainerScrollFallback(beitragMedienColumn)
    enableBeitragTextSticky(beitragText)
  } else if (gsapBeitragAnimation) {
    gsapBeitragAnimation.kill()
    gsapBeitragAnimation = null
    beitragMedien && gsap.set(beitragMedien, { clearProps: 'transform' })
    resetBeitragMediaColumnLayout(beitragMedienColumn)
    resetBeitragTextSticky(beitragText)
  } else {
    resetBeitragMediaColumnLayout(beitragMedienColumn)
    resetBeitragTextSticky(beitragText)
  }
}

beitragScrollSync()
window.addEventListener('resize', _.debounce(beitragScrollSync, 1000))

// Scrollgeschwindigkeiten von #beitragMedien und #beitragText angleichen
let gsapStudienrichtungAnimation
function studienrichtungScrollSync() {
  const scrollContainer = document.getElementById('mainstudienrichtung')
  const mediaContainer = document.querySelector('#studienrichtungContainerMedia .inner-container')
  const textContainer = document.getElementById('studienrichtungContainerText')
  // console.log(mediaContainer.clientHeight, window.innerHeight - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bar-height')) * 3), (mediaContainer.clientHeight > window.innerHeight - Number(getComputedStyle(document.documentElement).getPropertyValue('--bar-height')) * 3)
  // console.log(parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bar-height')))

  
  if (mediaContainer && textContainer && (mediaContainer.clientHeight > window.innerHeight - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bar-height')) * 3)) {
    gsap.registerPlugin(ScrollTrigger)
    gsapStudienrichtungAnimation && gsapStudienrichtungAnimation.revert()
    
    gsapStudienrichtungAnimation = gsap.matchMedia().add("(min-width: 720px)", () => {

      gsap.to(mediaContainer, {
        y: (-mediaContainer.clientHeight + scrollContainer.clientHeight), // Endposition
        ease: "none",
        scrollTrigger: {
          scroller: mediaContainer.parentElement.parentElement,
          trigger: textContainer,
          start: "top top", // Start bei unterem Ende des Viewports
          end: "bottom bottom", // Ende bei oberem Ende des Viewports
          scrub: true, // Glätte die Animation mit Scrollen
          // markers: true,
          // onUpdate: (self) => {
          //   console.log("progress:", self.progress)
          //   console.log(textContainer.clientHeight + " - " + mediaContainer.clientHeight + " = " + (textContainer.clientHeight - medien.clientHeight), self.progress.toFixed(2))
          // },
        },
      });

    })
  } else if (gsapStudienrichtungAnimation) {
    gsapStudienrichtungAnimation.kill()
  }
}

studienrichtungScrollSync()
window.addEventListener('resize', _.debounce(studienrichtungScrollSync, 1000))

// TAUBE
// Funktion, die zufällig jede 1, 2 oder 5 Minuten einer Klasse ein Element hinzufügt und entfernt
const taube = document.getElementById('taube');
const taubeBrief = document.getElementById('taubeBrief')
const overlayTaubenbrief = document.getElementById('overlayTaubenbrief')
const closeBrief = document.getElementById('closeBrief')

if (taube) {
  function taubeFliegt() {
    const delay = [20, 40, 60][Math.floor(Math.random() * 3)] * 1000;
    const animation = lottie.loadAnimation({
      container: taube,
      renderer: 'svg', // Choose the renderer (e.g., 'svg', 'canvas')
      loop: true,
      autoplay: true,
      path: 'dateien-statisch/240601_Microsite_Taube_Animation.json' // Path to your Lottie JSON file
    });
  
    setTimeout(() => {
      taube.className = ""
      setTimeout(() => {
        taube.classList.add('fliegt');
        // Zufällige Generierung einer Zahl von 0 bis 2
        const randomNumber = Math.floor(Math.random() * 3);
        // Array mit den drei Klassen
        const klassenHoehe = ["hoehe-1", "hoehe-2", "hoehe-3"];
        // Zufällige Klasse hinzufügen
        // taube.classList.add(klassenHoehe[randomNumber]);
        const randomTopDistance = Math.floor(Math.random() * (90 - 10 + 1) + 10); 
        taube.style.top = `${randomTopDistance}vh`;
      }, 500)
      taubeFliegt();
    }, delay); // Zufällige Zeitspanne von 1, 2 oder 5 Minuten in Millisekunden
  }
  taubeFliegt();

  if (taubeBrief) {
    taube.addEventListener('click', () => {
      document.body.setAttribute('tauben-brief-sichtbar', '')
    })

    overlayTaubenbrief.addEventListener('click', () => {
      document.body.removeAttribute('tauben-brief-sichtbar')
    })

    closeBrief.addEventListener('click', () => {
      document.body.removeAttribute('tauben-brief-sichtbar')
    })
  }
}


// VARIABLES
const breakpointSmall = Number(getComputedStyle(document.body).getPropertyValue('--breakpoint-small').replace('px', ''))

// CONFIGURATION
function desktopConfiguration() {
  setupGlobalNavigation()
  setupFlickities()
  destroyBewerbungsAsideArticles()
}

function mobileConfiguration() {
  destroyGlobalNavigation()
  setupFlickities()
  setupBewerbungsAsideArticles()
}

// INITIALIZATIONS

// Initialize: Vanilla Lazyload
if (window.innerWidth > breakpointSmall) {
  const lazyloadContainers = document.querySelectorAll('.lazyload-container')
  if (lazyloadContainers) {
    lazyloadContainers.forEach(container => {
      new LazyLoad({
        container: container,
        threshold: 1000,
      })
    })
  }
} else {
  new LazyLoad({
    threshold: 300,
  })
}

// Initialize: Flickity
let flickityElements = []
function setupFlickities() {
  const flickityCarousels = document.querySelectorAll('.carousel')

  if (flickityCarousels && flickityElements.length == 0) {
    flickityCarousels.forEach((carousel, index) => {
      flickityElements[index] = new Flickity(carousel, {
        wrapAround: true,
        autoPlay: 6000,
        selectedAttraction: 0.0075,
        friction: 0.2,
        lazyLoad: 2,
        prevNextButtons: false,
      })
    })
  } else {
    setTimeout(() => {
      flickityElements.forEach(element => {
        element.resize()
        element.reposition()
      })
    }, 100)
  }

  
}

// Button: Navigation
const globalNavigationContainerMinifiedNavigation = document.getElementById('globalNavigationContainerMinifiedNavigation')
const globalNavigation = document.getElementById('globalNavigation')
function setupGlobalNavigation() {
  globalNavigationContainerMinifiedNavigation.addEventListener('mouseenter', () => {
    document.body.classList.add('global-navigation-extended')
  })
  globalNavigation.addEventListener('mouseleave', () => {
    document.body.classList.remove('global-navigation-extended')
  })
}

function destroyGlobalNavigation() {
  if (desktopSetup) {
    globalNavigationContainerMinifiedNavigation.removeEventListener('mouseenter', () => {})
    globalNavigation.removeEventListener('mouseleave', () => {})
  }
}

// Mobile: Overlay Backdrop
const overlayBackdrop = document.getElementById('overlayBackdrop')
if (overlayBackdrop) {
  overlayBackdrop.addEventListener('click', () => {
    document.body.classList.remove('mobile-filter-visible')
  })
}

// Mobile: Navigation: Open via Button
const buttonMobileGlobalNavigation = document.getElementById('buttonMobileGlobalNavigation')
if (buttonMobileGlobalNavigation) {
  buttonMobileGlobalNavigation.addEventListener('click', () => {
    document.body.classList.toggle('mobile-global-navigation-visible')
  })
}

// Mobile: Navigation: Close via Button
const buttonMobileCloseGlobalNavigation = document.getElementById('buttonMobileCloseGlobalNavigation')
if (buttonMobileCloseGlobalNavigation) {
  buttonMobileCloseGlobalNavigation.addEventListener('click', () => {
    document.body.classList.remove('mobile-global-navigation-visible', 'mobile-global-navigation-instagram-visible')
  })
}

// Mobile: Navigation: Social Media Instagram: Open via Button
const buttonMobileInstagram = document.getElementById('buttonMobileInstagram')
const buttonMobileCloseInstagram = document.getElementById('buttonMobileCloseInstagram')

if (buttonMobileInstagram) {
  buttonMobileInstagram.addEventListener('click', () => {
    const aufklappbarerInhalt = document.getElementById('instagramAccounts')
    if (aufklappbarerInhalt.getAttribute('data-collapsed') == 'true') {
      expandSection(aufklappbarerInhalt)
      document.body.classList.add('mobile-global-navigation-instagram-visible')
    } else {
      collapseSection(aufklappbarerInhalt)
      document.body.classList.remove('mobile-global-navigation-instagram-visible')
    }
  })
}

if (buttonMobileCloseInstagram) {
  buttonMobileCloseInstagram.querySelector('button').addEventListener('click', () => {
    document.body.classList.remove('mobile-global-navigation-instagram-visible')
  })
}

// Mobile: Filter: Open via Button
const mobileButtonFilter = document.getElementById('mobileButtonFilter')
if (mobileButtonFilter) {
  mobileButtonFilter.addEventListener('click', () => {
    document.body.classList.toggle('mobile-filter-visible')
  })
}

// Button: Open/Close Search
const buttonOpenSearch = document.getElementById('buttonOpenSearch')
const inputSearch = document.querySelector('input[type="search"]')
if (buttonOpenSearch) {
  buttonOpenSearch.addEventListener('click', () => {
    document.body.classList.toggle('search-opened')
    if (document.body.classList.contains('search-opened')) {
      inputSearch.focus()
    }
  })
}

// Aktuelles: Isotope Layout
let isotopeAktuellesMainBeitraege
const aktuellesMainBeitraege = document.querySelector('#aktuellesMainBeitraege .inner-container')
if (aktuellesMainBeitraege) {

  // Masonry Initialization
  isotopeAktuellesMainBeitraege = new Masonry(aktuellesMainBeitraege, {
    itemSelector: '.aktuelles-main-beitrag',
    columnWidth: '.grid-sizer',
    transitionDuration: 0,
    stagger: 0,
    gutter: 0,
  })

  // Layout after Images are loaded
  imagesLoaded(aktuellesMainBeitraege, () => {
    isotopeAktuellesMainBeitraege.layout()
    // console.log('images-loaded')
  })

  // Show Masonry Layout when arrange is complete
  isotopeAktuellesMainBeitraege.on('layoutComplete', () => {
    // console.log('arrange-complete')
    aktuellesMainBeitraege.classList.add('arrange-complete')
  })

  // Aktuelles: Isotope Filter
  const buttonsstudienrichtungen = document.querySelectorAll('#navigationstudienrichtungen ul button')
  if (buttonsstudienrichtungen) {
    let isotopeFilter
    buttonsstudienrichtungen.forEach(button => button.addEventListener('click', () => {
      button.setAttribute('data-active', !(button.getAttribute('data-active') == 'true'))
      isotopeFilter = ''
      buttonsstudienrichtungen.forEach((button, index) => {
        if (button.getAttribute('data-active') == 'true') {
          (index != 0 && isotopeFilter.length) && (isotopeFilter += ', ')
          isotopeFilter += '.' + button.getAttribute('data-studienrichtung')
        }
      })
      isotopeAktuellesMainBeitraege.arrange({ filter: isotopeFilter })
    }))
  }
}
    
  
// Aktuelles, Termine: Scroll under Archive
const aktuellesAsideTermine = document.querySelectorAll('.aktuelles-aside-termin')
const aktuellesAsideFirstTerminInTheFuture = document.querySelector('#aktuellesAsideTermine .aktuelles-aside-termin:not(.archiviert)')

if (aktuellesAsideTermine.length && aktuellesAsideFirstTerminInTheFuture) {
  const containerAktuellesAsideTermine = document.getElementById('aktuellesAsideTermine')
  
  window.addEventListener('load', () => {
    document.getElementById('aktuellesAsideTermineContent').scrollTop = aktuellesAsideFirstTerminInTheFuture.offsetTop + Number(getComputedStyle(aktuellesAsideFirstTerminInTheFuture).getPropertyValue('border-top-width').replace('px', ''))
  })
}

if (aktuellesAsideTermine.length) {
  // Aktuelles, Termine: Expand/Collapse
  aktuellesAsideTermine.forEach(termin => {
    const terminButtonExtend = termin.querySelector('.aktuelles-aside-termin-button_aufklappen')
    if (terminButtonExtend) {
      terminButtonExtend.addEventListener('click', () => {
        const aufklappbarerInhalt = termin.querySelector('.aktuelles-aside-termin-aufklappbarer_inhalt')
        if (aufklappbarerInhalt.getAttribute('data-collapsed') == 'true') {
          expandSection(aufklappbarerInhalt)
        } else {
          collapseSection(aufklappbarerInhalt)
        }
      })
    } else {
      termin.addEventListener('click', () => {
        const aufklappbarerInhalt = termin.querySelector('.aktuelles-aside-termin-aufklappbarer_inhalt')
        if (aufklappbarerInhalt.getAttribute('data-collapsed') == 'true') {
          expandSection(aufklappbarerInhalt)
        } else {
          collapseSection(aufklappbarerInhalt)
        }
      })
    }
  })
}

// Mobile: Aktuelles, Termine: Open via Button
const buttonMobilTermine = document.getElementById('buttonMobilTermine')
const buttonMobilCloseTermine = document.getElementById('buttonMobileTermine')
if (buttonMobilTermine) {
  buttonMobilTermine.addEventListener('click', () => {
    document.body.classList.add('mobile-termine-visible')
  })
}
if (buttonMobilCloseTermine) {
  buttonMobilCloseTermine.addEventListener('click', () => {
    document.body.classList.remove('mobile-termine-visible')
  })
}

// Mobile: Aktuelles, Termine: Close via Button
const buttonMobileCloseTermine = document.getElementById('buttonMobileCloseTermine')
if (buttonMobileCloseTermine) {
  buttonMobileCloseTermine.addEventListener('click', () => {
    document.body.classList.remove('mobile-termine-visible')
  })
}

// Bewerbung, Ablauf: Expand/Collapse
// const bewerbungAblaufUnterschritte = document.querySelectorAll('.bewerbung-ablauf-unterschritt')
// if (bewerbungAblaufUnterschritte) {
//   bewerbungAblaufUnterschritte.forEach(unterschritt => unterschritt.addEventListener('click', () => {
//     const text = unterschritt.querySelector('.bewerbung-ablauf-unterschritt-text')
//     if (text.getAttribute('data-collapsed') == 'true') {
//       expandSection(text)
//       unterschritt.classList.add('expanded')
//     } else {
//       collapseSection(text)
//       unterschritt.classList.remove('expanded')
//     }
//   }))
// }

// Bewerbung, aside: Expand/Collapse
let bewerbungAsideAddedEventListener = false

function expandBewerbungArticle(event) {
  const article = event.target.parentElement
  const content = article.querySelector('.bewerbung-aside-article-content')
  if (content.getAttribute('data-collapsed') == 'true') {
    expandSection(content)
    article.classList.add('expanded')
  } else {
    collapseSection(content)
    article.classList.remove('expanded')
  }
}

function setupBewerbungsAsideArticles() {
  const bewerbungAsideArticlesButtons = document.querySelectorAll('.bewerbung-aside-article')
  if (!bewerbungAsideAddedEventListener) {
    bewerbungAsideAddedEventListener = true
    bewerbungAsideArticlesButtons.forEach((button) => {
      button.addEventListener('click', expandBewerbungArticle)
    })
  }
}

function destroyBewerbungsAsideArticles() {
  const bewerbungAsideArticlesButtons = document.querySelectorAll('.oeffne-bewerbung-aside-article')
  bewerbungAsideArticlesButtons.forEach(button => {
    button.removeEventListener('click', expandBewerbungArticle)
    const article = button.parentElement
    article.querySelector('.bewerbung-aside-article-content').style = ''
    article.querySelector('.bewerbung-aside-article-content').setAttribute('data-collapsed', 'true')
  })
}

// Accordeon
// Quelle der Animations-Funktionen: https://css-tricks.com/using-css-transitions-auto-dimensions/#aa-technique-3-javascript
function collapseSection(element) {
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.scrollHeight

  // temporarily disable all css transitions
  var elementTransition = element.style.transition
  element.style.transition = 'height 650ms ease'

  // on the next frame (as soon as the previous style change has taken effect),
  // explicitly set the element's height to its current pixel height, so we
  // aren't transitioning out of 'auto'
  requestAnimationFrame(function() {
    element.style.height = sectionHeight + 'px'
    // element.style.transition = elementTransition

    // on the next frame (as soon as the previous style change has taken effect),
    // have the element transition to height: 0
    requestAnimationFrame(function() {
      element.style.height = 0 + 'px'
    })
  })

  // define a named function to handle the transitionend event
  function transitionEndHandler(e) {
    // remove this event listener so it only gets triggered once
    element.removeEventListener('transitionend', transitionEndHandler)

    element.style.transition = ''

    // remove "height" from the element's inline styles, so it can return to its initial value
    element.style.height = null
  }

  // when the next css transition finishes (which should be the one we just triggered)
  element.addEventListener('transitionend', transitionEndHandler)

  // mark the section as "currently collapsed"
  element.setAttribute('data-collapsed', 'true')
}


function expandSection(element) {
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.querySelector('.expand-content').clientHeight

  // have the element transition to the height of its inner content
  element.style.transition = 'height 650ms ease'
  element.style.height = sectionHeight + 'px'

  // define a named function to remove the event listener
  function transitionEndHandler(e) {
    // remove this event listener so it only gets triggered once
    element.removeEventListener('transitionend', transitionEndHandler)
  }

  // when the next css transition finishes (which should be the one we just triggered)
  element.addEventListener('transitionend', transitionEndHandler)

  // mark the section as "currently not collapsed"
  element.setAttribute('data-collapsed', 'false')
}

// Mouse Move
// const bardSetQuotes = document.querySelectorAll('.bard_set-quote')
// if (bardSetQuotes.length) {
//   if (window.innerWidth >= breakpointSmall) {
//     document.addEventListener('mousemove', (event) => {
//       let fontVariationSettings = '"wght" ' + (600 + 200 * event.pageX/window.innerWidth) + ', "wdth" ' + (60 + 40 * event.pageX/window.innerWidth)
//       document.documentElement.style.setProperty('--font-variations-settings-quote', fontVariationSettings)
//     })
//   }
// }


// WINDOW RESIZE
let desktopSetup = false
let breakpointSmallMatchMedia = window.matchMedia("(max-width: " + breakpointSmall + "px)");
if (breakpointSmallMatchMedia.matches) {
  mobileConfiguration()
} else {
  desktopConfiguration()
  desktopSetup = true
}
breakpointSmallMatchMedia.addEventListener('change', () => {
  if (breakpointSmallMatchMedia.matches) {
    mobileConfiguration()
    desktopSetup = false
  } else {
    desktopConfiguration()
    desktopSetup = true
  }
})